export default {
  simulationDataIsMissing: 'Bitte die Werkstoffzusammensetzung vervollständigen und ein Berechnungsmodell auswählen.',
  errorMinLargerMax: 'min > max',
};
